<template>
  <div class="page">
    <Nav />
    <div class="app-wrapper">
      <div class="app-content pt-3 p-md-3 p-lg-4">
        <div class="container-fluid">
          <div class="row mt-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="table-box">
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-lg-6 p-4">
                    <h4>Pocket Box Plus Companies Users</h4>
                    <p>{{ CompanyName }} - Users</p>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-6 p-4">
                    <router-link
                      :to="{ name: 'Companies' }"
                      class="btn btn-primary float-end"
                    >
                      &larr; Back</router-link
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 px-4 mt-3 mb-3">
                    <div class="table-responsive table-color">
                      <table
                        class="table"
                        width="100%"
                        border="0"
                        id="company_users_list"
                      >
                        <thead>
                          <tr>
                            <th>Profile Image</th>
                            <th>Name</th>
                            <th>Email Address</th>
                            <th>User Type</th>
                            <th>Contact Number</th>
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody v-if="showLoader">
                          <tr>
                            <td>
                              <Loading />
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr v-for="(User, index) in Users" :key="index">
                            <td align="center">
                              <div class="profile-image">
                                <img
                                  :src="
                                    GetProfileImage(User.id, User.profile_image)
                                  "
                                  class="listingIMG"
                                  :title="User.forename"
                                  :alt="User.forename"
                                  @error="
                                    $event.target.src = GetProfileImage(
                                      User.id,
                                      User.profile_image
                                    )
                                  "
                                />
                              </div>
                            </td>
                            <td>{{ User.forename }} {{ User.surname }}</td>
                            <td>{{ User.email }}</td>
                            <td>
                              {{
                                User.company_role == 1
                                  ? "Admin"
                                  : "Sales Person"
                              }}
                            </td>
                            <td>{{ User.phone }}</td>
                            <td class="text-center">
                              <router-link
                                :to="{
                                  name: 'UpdateCompanyUser',
                                  params: { UserId: User.id },
                                }"
                                class="btn btn-primary btn-xs"
                                title="Edit User"
                                >Edit</router-link
                              >
                              <button
                                class="btn btn-primary btn-link1 btn-xs"
                                v-on:click="UserDelete(User.id)"
                                style="margin-left: 10px"
                                title="Delete Record"
                              >
                                Delete
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary btn-xs"
                                v-on:click="UpdatePassword(User.id)"
                                data-bs-toggle="modal"
                                data-bs-target="#updateCompanyUserPassword"
                                title="Update Password"
                                style="margin-left: 10px"
                              >
                                Update Password
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary btn-xs"
                                @click="setQRCode(User.company_id, User.id)"
                                data-bs-toggle="modal"
                                data-bs-target="#qrcodeModal"
                                title="View QR Code"
                                style="margin-left: 10px"
                              >
                                QR Code
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal">
      <updateCompanyUserPassword
        :updatePasswordID="updatePasswordID"
        :key="ComponentKey + 20"
        ref="updateCompanyUserPassword"
      ></updateCompanyUserPassword>
      <plusUserQRCode
        :QRCodeEndpoint="QRCodeEndpoint"
        :PageTitle="PageTitle"
        :key="ComponentKey + 30"
        ref="plusUserQRCode"
      ></plusUserQRCode>
    </div>
  </div>
</template>
<script>
  import "datatables.net-dt/js/dataTables.dataTables";
  import "datatables.net-dt/css/jquery.dataTables.min.css";
  import "jquery/dist/jquery.min.js";
  import $ from "jquery";

  import plusUserQRCode from "@/views/Company/QRCode";
  import addCompanyUser from "@/views/Company/User/Create";
  import editCompanyUser from "@/views/Company/User/Update";
  import updateCompanyUserPassword from "@/views/Company/User/UpdatePassword";
  import Nav from "@/components/Navigation";
  import Axios from "axios";
  import Endpoints from "@/Admin/Endpoints";
  import Loading from "@/components/Loading";
  import Swal from "sweetalert2";
  export default {
    components: {
      Nav,
      Loading,
      addCompanyUser,
      editCompanyUser,
      updateCompanyUserPassword,
      plusUserQRCode,
    },
    data() {
      return {
        showLoader: false,
        CompanyId: 0,
        Users: {},
        editRec: {},
        updatePasswordID: "",
        CompanyName: "",
        ComponentKey: 0,
        QRCodeEndpoint: "",
        PageTitle: "Plus User QR Code",
      };
    },
    mounted() {
      document.title = "PocketBox Admin - Plus Company Users";
      this.CompanyId = this.$route.params.CompanyId;
      this.GetCompanyUsersList();
    },
    methods: {
      forceRerender() {
        this.ComponentKey += 1;
      },
      GetCompanyUsersList() {
        this.showLoader = true;
        Axios.post(Endpoints.Company.User.List, {
          token: localStorage.getItem("token"),
          company_id: this.CompanyId,
        }).then((Response) => {
          this.Users = Response.data.records;
          this.CompanyName = Response.data.company_name;
          this.showLoader = false;
          setTimeout(() => {
            $("#company_users_list").DataTable({
              aaSorting: [],
              bDestroy: true,
              language: {
                search: "",
                searchPlaceholder: "Search...",
                paginate: {
                  next: "&#8594;", // or '→'
                  previous: "&#8592;", // or '←'
                },
              },
              oLanguage: {
                sLengthMenu: "Show _MENU_",
              },
              columnDefs: [
                {
                  targets: [5],
                  orderable: false,
                },
              ],
            });
          }, 1000);
        });
      },
      refreshList() {
        this.$router.go();
      },
      GetProfileImage(Id, ProfileImage) {
        if (ProfileImage == "" || ProfileImage == 1 || ProfileImage == 0) {
          return "/assets/images/avatar.jpg";
        } else {
          return (
            Endpoints.Helper.MarketplaceImage +
            Id +
            "/" +
            localStorage.getItem("token") +
            "/user-profile-image"
          );
        }
      },
      getRecord(id) {
        Axios.post(Endpoints.Company.User.Get, {
          token: localStorage.getItem("token"),
          id: id,
        }).then((Response) => {
          this.editRec = Response.data.record;
          this.$refs.editCompanyUser.GetProfileImage(
            this.editRec.profile_image
          );
        });
      },
      UpdatePassword(id) {
        this.updatePasswordID = id;
      },
      setQRCode(CompanyId, UserId) {
        let EncodedLink = encodeURIComponent(
          `http://www.pocketbox.co.uk?company=${CompanyId}&plus_user_id=${UserId}`
        );
        var ContentString = btoa(
          `https://pocketbox.page.link/?link=${EncodedLink}&apn=com.pocketbox.app&ibi=com.pocketbox.app&isi=1556393851&ofl=http://www.pocketbox.co.uk`
        );
        this.QRCodeEndpoint =
          Endpoints.QR.Generate + "?content=" + ContentString;
      },
      UserDelete(id) {
        Swal.fire({
          title: "Are you sure to delete this Plus Company User?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("../../../assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Company.User.Remove, {
              token: localStorage.getItem("token"),
              id: id,
            }).then((Response) => {
              if (Response.data.success == true) {
                Swal.fire(
                  "Plus Company User Deleted Successfully",
                  "",
                  "success"
                ).then(() => {
                  this.refreshList();
                });
              } else {
                Swal.fire({
                  title: "Oops!",
                  html: Response.data.message,
                  icon: "error",
                  confirmButtonText: "Close",
                });
              }
            });
          }
        });
      },
    },
  };
</script>
<style>
  .card-title p {
    font-size: 14px;
    color: #6d6d6d;
    margin-bottom: 0;
  }
  h2.page-title {
    padding: 15px 0;
  }
  .float-end {
    margin-left: 10px;
  }
  .profile-image img {
    max-width: 50px;
    max-height: 50px;
    vertical-align: middle;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .profile-image {
    position: relative;
    text-align: center;
    width: 60px;
    padding: 5px;
    height: 60px;
    background: #ccc;
  }
  .fa {
    color: #fff;
  }
</style>
